import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GenSpecialProgramComponent } from './special-program.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { I18nModule } from "@spartacus/core";
import { IconModule, NgSelectA11yModule } from "@spartacus/storefront";

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    NgSelectA11yModule,
    IconModule,
    I18nModule
  ],
  declarations: [GenSpecialProgramComponent],
  exports: [GenSpecialProgramComponent],
})
export class GenSpecialProgramModule {}
